import styled from 'styled-components';

const StyledContent = styled.div`
  background-color: #a0dfff;
  border: 2px solid #427994;
  border-radius: 8px;
  padding: 8px;
  margin-left: 10px;
  h3 {
    font-family: 'Maison Neue';
    font-size: 20px;
    color: black;
    font-weight: 700;
    margin-bottom: 0;
    margin-top: 0;
  }
`;
export default StyledContent;
